export const TINY_DATA = [
  // 'bmdgu9hi6tifhhev9hhd3vgdyax49veokf3jghpfjiptl3fj', // cigelesunuso@gotgel.org // https://tempmail.email // 04/9/2024
  't0lry0jlow79gjdg6ixon8aat0stmg89pgb8ps035s8ngejh', // duhodajum.nudifola@rungel.net
  'uzcikdwtdyjn91qiezje7n2b31a9a711cu3hh2kyaysace6d', // jegisiriti@gotgel.org
  'skv6ss64py6hqp0rkl8vu389q7s5gc282jai2sxivvfh4g8d', // levovenemis@rungel.net
  'hxvwoxgx9o9udkjrg4gr56amc2kvu0gccmopw81qxwz0zpby', // mijabuci.evevesot@rungel.net
  // 'bj5liq7beipynck2zsx5yyudiockq36gi64pzoznf425ixzs', // furimumef.metipave@jollyfree.com
  'cvkelm6bux3kx0mgdvzwlsbsdtjg39iflpfelumjbic7dnoz', // riseqih.mumivi@rungel.net
  '8ktmx4z0uwj6umbi6gqs6ng4czmkuiglhqiczh0fgmncxgm3', // joperaj.jujulef@rungel.net
  'svtedx9fnl9auwk86htqq10a5injyvvsmddkveubett9xim8', // hafono.ehafil@gotgel.org
  '1a81x75zfv0uvy2pkf4zrm32uv0cqoa04zsajleiz4qdmpyw', // qanejima.ijadeva@jollyfree.com
  'ubqsvtck0i1vh9h95p0jvxbms1tpccwd0l3ptls6m25c33jw', // jejulij.pihopu@rungel.net
  'kdowtfr782vbpstnml8skz3advlbt4xvxuyyaez1n6m1laol', // pobesojucupo@jollyfree.com
  '178zwkow3aoz4epz5vsousf0oo24cj0kqvqwvid0znv1x483', // goqapeqo@gotgel.org
  '59o719g6iqwmslgqogdcvhe7l1z5a749j7wr51vd5b3e56d1', // macedobadim@jollyfree.com
  'r5kv61a9bp1dz6oiwsx338ywxc3i9mdj3ryb3xvgvi5mf5zb', // hetofepiloq@rungel.net
  'yqzlu83e6xbe6o44nh24cmz9q5trdi053iv1ind7w8c8tjat', // cegunasetetu@jollyfree.com
  'lzgn15r8fcom7v46pwrs9yq64c17ftip6vpl2leegyih65w3', // lafoviqipupe@jollyfree.com
  '4sk0ufqbj4hh9g64c1fl3ludk2phi9q5hucbc76g4cnfxfj0', // gitosadilitu@jollyfree.com
  'txtjyey8xneblo972n8lgyqjjvop68bf2cteopma0nlpsx76', // sesefevur.micumoqim@rungel.net
  'ikr2he27o5xajmwuyjg45m3ix1lug5jbzj67bfarv48ohsrt', // dufegic.sicema@gotgel.org
  'lyn8l8mrasub7t49u0siu5u9d4w4k5g32ouzhwwr66w4t6ox', // nihimita@rungel.net
  '6m1wld2iaigfuiij2ji4kcnzkoibo3h4tgrl6c0opw909oc2', // pajafafu@rungel.net

  'oitzrcpf1gaib8afrfw4rflmf2c06ptjr1pw23rta47hlb50', //ledob34282@cantozil.com // 28/11/2024
  'a7bufn0gemn9kbph7dlg5slt6ao09rp5ru59ahsp9z8n8g2l', //gocej10222@kindomd.com
]

// https://insightsassistant.mavenmagnet.com/
// https://staging-ia.mavenmagnet.com/
